import apiClient from "./axios.config";
import Cookies from "js-cookie";
const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchCategories = async () => {
  const response = await apiClient.get("website/category/all", { headers });
  return response.data;
};

export const fetchSubCategories = async () => {
  const response = await apiClient.get("website/sub-category/all", { headers });
  return response.data;
};

export const fetchSubCategoriesByCategory = async (id) => {
  const response = await apiClient.get(`website/sub-category/${id}"`, {
    headers,
  });
  return response.data;
};
